import { FC, ReactNode } from "react";

type PageHeroProps = {
  bkg_a: string;
  bkg_b: string;
  sub_head: string;
  main_head: ReactNode;
  description: ReactNode;
  children: ReactNode;
}

const PageHero: FC<PageHeroProps> = ({ bkg_a, bkg_b, sub_head, main_head, description, children }) => {
  return (
    <section className="flex items-center justify-center h-[435px] mt-[90px]">
      {/* Fist Column */}
      <div className="w-[120px] h-full bg-primaryDark-400"></div>

      {/* Second Column */}
      <div className="w-[116px] h-full overflow-hidden">
        <img src={bkg_a} alt="Hero Background" className="w-full h-[437px]" />
      </div>

      {/* Third Column */}
      <div className="w-[500px] h-full overflow-hidden">
        <img src={bkg_b} alt="Hero Background" className="w-full h-[437px]" />
      </div>

      {/* Fourth Column */}
      <div className="w-[calc(100%-856px)] h-full px-[56px] py-[40px]">
        <p className="text-[16px] font-open-sans font-bold text-primaryDark-0 mb-[10px]">{sub_head}</p>

        {/* Header */}
        <h2 className="text-[48px] font-raleway font-bold text-primaryDark-0 leading-tight mb-[16px]">{main_head}</h2>

        {/* Description */}
        <p className="text-[18px] font-text-0 font-open-sans mb-[16px] leading-loose max-w-[600px]">{description}</p>

        <div>{children}</div>
      </div>

      {/* Fifth Column */}
      <div className="w-[120px] h-full bg-primaryDark-400"></div>
    </section >
  )
}

export default PageHero;